var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgObject(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.234,
    height: 21.93,
    viewBox: "0 0 18.234 21.93",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Path_8116",
    "data-name": "Path 8116",
    transform: "translate(2008.714 2818.343)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8117",
    "data-name": "Path 8117",
    d: "M-1990.891-2813.618l-8.326-4.63a.823.823,0,0,0-.38-.095.751.751,0,0,0-.388.1l-8.318,4.622a.8.8,0,0,0-.411.7v11.088a.8.8,0,0,0,.411.7l8.318,4.63a.837.837,0,0,0,.776,0l8.318-4.63a.8.8,0,0,0,.411-.7v-11.088A.806.806,0,0,0-1990.891-2813.618Zm-9.5,15.069-6.735-3.751v-9.268l6.735,3.743Zm.791-10.653-6.679-3.72,6.679-3.719,6.688,3.719Zm7.535,6.9-6.735,3.751v-9.276l6.735-3.743Z",
    transform: "translate(0 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObject);
export default __webpack_public_path__ + "static/media/object.7585d24e.svg";
export { ForwardRef as ReactComponent };